import React from 'react'
import { SvgIcon } from '@mui/material'

export const ShareIcon = props => (
  <SvgIcon viewBox="0 0 24 24" sx={{ color: 'secondary.main' }} {...props}>
    <path
      d="M18 14a4 4 0 0 0-3.08 1.48l-5.1-2.35c.24-.73.24-1.53 0-2.26l5.1-2.35a4 4 0 1 0-.85-1.81L8.79 9.14a4 4 0 1 0 0 5.72l5.28 2.43A4 4 0 1 0 18 14Zm0-10a2 2 0 1 1 0 4 2 2 0 0 1 0-4ZM6 14a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm12 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"
      fill="inherit"
    />
  </SvgIcon>
)
